import React from "react";
import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css';
import './ItemDetails.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import '../../../node_modules/swiper/swiper.css';
import 'swiper/css/navigation';

const ItemDetails = ({ id, nombre, precio, imagen,titulo ,superficieTotal,ambientes,baños, disponibilidad}) => {
  const navigate = useNavigate();



  const svgSupTotal = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      style={{ enableBackground: "new 0 0 512 512",height:"2.5rem" }}
      xmlSpace="preserve"
    >
      <path d="M93.867 426.667h409.6c5.12 0 8.533-3.413 8.533-8.533V8.533C512 3.413 508.587 0 503.467 0H93.866c-5.12 0-8.533 3.413-8.533 8.533v409.6c0 5.12 3.414 8.534 8.534 8.534zm8.533-136.534h85.333c-4.267 45.227-40.107 81.067-85.333 85.333v-85.333zm0-273.066h136.533v51.2H230.4c-5.12 0-8.533 3.413-8.533 8.533s3.413 8.533 8.533 8.533h34.133c5.12 0 8.533-3.413 8.533-8.533s-3.413-8.533-8.533-8.533H256v-51.2h76.8v93.867c0 5.12 3.413 8.533 8.533 8.533h34.133V128c0 5.12 3.413 8.533 8.533 8.533s8.533-3.413 8.533-8.533V93.867c0-5.12-3.413-8.533-8.533-8.533s-8.533 3.413-8.533 8.533v8.533h-25.6V17.067h145.067V102.4H460.8v-8.533c0-5.12-3.413-8.533-8.533-8.533-5.12 0-8.533 3.413-8.533 8.533V128c0 5.12 3.413 8.533 8.533 8.533 5.12 0 8.533-3.413 8.533-8.533v-8.533h34.133V256h-51.2v-8.533c0-5.12-3.413-8.533-8.533-8.533s-8.533 3.413-8.533 8.533V281.6c0 5.12 3.413 8.533 8.533 8.533s8.533-3.413 8.533-8.533v-8.533h51.2V409.6H307.2V273.067h51.2v8.533c0 5.12 3.413 8.533 8.533 8.533s8.533-3.413 8.533-8.533v-34.133c0-5.12-3.413-8.533-8.533-8.533s-8.533 3.413-8.533 8.533V256h-59.733c-5.12 0-8.533 3.413-8.533 8.533V409.6H102.4v-17.388c57.425-4.332 102.4-52.044 102.4-110.612 0-5.12-3.413-8.533-8.533-8.533H102.4v-51.2h145.067c5.12 0 8.533-3.413 8.533-8.533V153.6h8.533c5.12 0 8.533-3.413 8.533-8.533 0-5.12-3.413-8.533-8.533-8.533H230.4c-5.12 0-8.533 3.413-8.533 8.533 0 5.12 3.413 8.533 8.533 8.533h8.533v51.2H102.4V17.067zm-36.693 407.04c3.413-3.413 3.413-8.533 0-11.947-3.413-3.413-8.533-3.413-11.947 0l-11.093 11.093V29.013L53.76 40.107c1.707 1.707 3.413 2.56 5.973 2.56s4.267-.853 5.973-2.56c3.413-3.413 3.413-8.533 0-11.947L41.567 4.02C40.172 1.511 37.532 0 34.133 0s-6.038 1.511-7.434 4.02L2.56 28.16c-3.413 3.413-3.413 8.533 0 11.947s8.533 3.413 11.947 0L25.6 29.013v394.24L14.507 412.16c-3.413-3.413-8.533-3.413-11.947 0-3.413 3.413-3.413 8.533 0 11.947l24.14 24.14c1.395 2.509 4.034 4.02 7.434 4.02 3.399 0 6.038-1.511 7.433-4.02l24.14-24.14zM512 477.874v-.016c-.002-3.395-1.512-6.031-4.02-7.426l-24.14-24.14c-3.413-3.413-8.533-3.413-11.947 0-3.413 3.413-3.413 8.533 0 11.947l11.093 11.093H88.747L99.84 458.24c3.413-3.413 3.413-8.533 0-11.947-3.413-3.413-8.533-3.413-11.947 0l-24.14 24.14c-2.509 1.395-4.02 4.034-4.02 7.434s1.511 6.038 4.02 7.434l24.14 24.14c1.707 1.707 3.413 2.56 5.973 2.56s4.267-.853 5.973-2.56c3.413-3.413 3.413-8.533 0-11.947L88.747 486.4h394.24l-11.093 11.093c-3.413 3.413-3.413 8.533 0 11.947 1.707 1.707 3.413 2.56 5.973 2.56s4.267-.853 5.973-2.56l24.14-24.14c2.507-1.394 4.017-4.03 4.02-7.426z" />
    </svg>
  );

  const Ambientes = (
    <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="2.5rem"
    height="2.5rem"
    viewBox="0 0 1244.000000 1280.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
      <path d="M7764 11623 c3 -148 11 -438 17 -646 6 -208 8 -381 5 -385 -3 -3 -6
      29 -6 70 l0 75 -42 -9 c-74 -16 -151 -29 -212 -36 l-60 -7 42 -28 c59 -38 53
      -43 -8 -6 -28 17 -47 35 -43 41 3 7 1 8 -5 4 -6 -4 -270 166 -589 378 -317
      212 -578 384 -580 382 -2 -2 1 -181 8 -397 10 -342 13 -396 28 -410 9 -9 454
      -306 989 -660 2204 -1460 3237 -2149 3234 -2160 -1 -6 2 -8 7 -4 6 3 151 -86
      323 -199 l312 -205 169 257 c93 141 171 262 173 267 2 6 -656 451 -1463 990
      -806 539 -1536 1028 -1623 1087 l-157 107 -6 158 c-3 87 -15 464 -27 838 -11
      374 -23 699 -26 723 l-5 42 -231 0 -231 0 7 -267z"/>
      <path d="M5710 11184 c-234 -158 -1352 -913 -2485 -1678 -1133 -765 -2117
      -1429 -2187 -1476 -70 -47 -126 -89 -124 -95 2 -5 80 -126 173 -267 l169 -257
      469 307 c259 169 505 332 548 361 43 29 80 51 83 49 2 -3 -98 -71 -221 -153
      -124 -81 -224 -149 -222 -151 11 -11 107 -13 156 -3 92 19 131 53 213 189 28
      47 59 91 70 98 10 7 16 17 13 22 -3 4 631 428 1408 941 776 514 1629 1078
      1895 1254 l484 320 -2 260 c-2 143 -5 329 -9 413 l-6 152 -425 -286z"/>
      <path d="M10142 8079 c7 -13 16 -26 19 -29 3 -3 12 -15 18 -28 7 -13 20 -33
      29 -44 82 -101 121 -124 230 -131 39 -3 76 -8 82 -12 5 -3 10 -4 10 -1 0 4
      -348 238 -388 261 -11 6 -11 3 0 -16z"/>
      <path d="M2380 7904 c-135 -103 -266 -203 -292 -222 l-48 -36 0 -2893 0 -2893
      285 0 284 0 3 202 c2 112 5 617 6 1123 1 506 5 1817 9 2913 3 1095 4 1992 2
      1992 -2 0 -115 -84 -249 -186z"/>
      <path d="M9813 5865 c4 -1226 7 -2629 7 -3117 l0 -888 290 0 290 0 -1 2893 0
      2892 -27 21 c-15 11 -142 108 -282 214 -140 106 -261 198 -269 204 -12 9 -13
      -299 -8 -2219z"/>
      <path d="M1720 1600 l0 -149 4413 1 c2426 1 4451 3 4500 5 l87 4 0 145 0 144
      -4500 0 -4500 0 0 -150z"/>
      <path d="M4510 1055 l0 -145 1710 0 1710 0 0 145 0 145 -1710 0 -1710 0 0
      -145z"/> 
    </g>
  </svg>
  );
  
  // Luego puedes usar {Ambientes} en tu renderizado
  
  

  const Baños =(
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    height={"2.5rem"}
    width={"2.5rem"}
    viewBox="0 0 512 512"
    style={{ enableBackground: 'new 0 0 512 512' }}
    xmlSpace="preserve"
  >
    <g transform="translate(1 1)">
      <g>
        <g>
          <path d="M485.4,272.067h-8.533v-179.2c0-42.667-34.133-76.8-76.8-76.8c-37.77,0-64.935,28.006-67.974,69.041     c-19.829,3.748-34.426,20.826-34.426,41.892c0,5.12,3.413,8.533,8.533,8.533h68.267c5.12,0,8.533-3.413,8.533-8.533     c0-20.833-14.274-37.769-33.767-41.767c2.55-27.116,18.836-52.1,50.834-52.1c33.28,0,59.733,26.453,59.733,59.733v179.2H202.975     c-3.86-19.681-20.878-34.133-41.841-34.133c-8.533-10.24-20.48-17.067-34.133-17.067c-16.213,0-30.72,9.387-37.547,23.04     c-6.827-3.413-14.507-5.973-22.187-5.973c-20.963,0-37.981,14.452-41.841,34.133H24.6c-14.507,0-25.6,11.093-25.6,25.6     c0,14.507,11.093,25.6,25.6,25.6h10.255l23.025,91.307c6.827,26.453,30.72,45.227,58.027,45.227h6.827l-11.093,22.187     c-2.56,4.267-0.853,9.387,3.413,11.093c0.853,0.853,2.56,0.853,3.413,0.853c3.413,0,5.973-1.707,7.68-4.267L141.08,459.8h236.8     l14.507,29.013c1.707,3.413,4.267,5.12,7.68,5.12c1.707,0,2.56,0,3.413-1.707c3.413-1.707,5.12-6.827,3.413-11.093     l-10.689-21.379c26.419-0.938,49.266-19.39,55.916-44.328l23.24-92.16h10.04c14.507,0,25.6-11.093,25.6-25.6     C511,283.16,499.907,272.067,485.4,272.067z M365.08,118.467h-48.64c3.413-10.24,13.653-17.067,24.747-17.067     S361.667,108.227,365.08,118.467z M67.267,255c7.68,0,14.507,3.413,20.48,9.387c1.707,2.56,5.12,3.413,8.533,2.56     s5.12-3.413,5.973-6.827c2.56-12.8,12.8-22.187,25.6-22.187c9.387,0,17.92,4.267,22.187,12.8c1.707,3.413,5.973,5.12,9.387,4.267     c0.853,0,1.707,0,2.56,0c11.093,0,20.48,6.827,23.893,17.067H43.373C46.787,261.827,56.173,255,67.267,255z M436.76,410.307     c-5.12,18.773-22.187,32.427-41.813,32.427H116.76c-19.627,0-36.693-13.653-41.813-32.427l-22.187-87.04h404.48L436.76,410.307z      M485.4,306.2h-17.067H41.667H24.6c-5.12,0-8.533-3.413-8.533-8.533s3.413-8.533,8.533-8.533h8.533h162.133H485.4     c5.12,0,8.533,3.413,8.533,8.533S490.52,306.2,485.4,306.2z"></path>
          <path d="M306.2,173.933c5.12,0,8.533-3.413,8.533-8.533v-4.267c0-5.12-3.413-8.533-8.533-8.533s-8.533,3.413-8.533,8.533v4.267     C297.667,170.52,301.08,173.933,306.2,173.933z"></path>
          <path d="M306.2,213.187c5.12,0,8.533-4.267,8.533-8.533v-9.387c0-5.12-3.413-8.533-8.533-8.533s-8.533,3.413-8.533,8.533v9.387     C297.667,209.773,301.08,213.187,306.2,213.187z"></path>
          <path d="M306.2,246.467c5.12,0,8.533-3.413,8.533-8.533v-4.267c0-5.12-3.413-8.533-8.533-8.533s-8.533,3.413-8.533,8.533v4.267     C297.667,243.053,301.08,246.467,306.2,246.467z"></path>
          <path d="M340.333,173.933c5.12,0,8.533-3.413,8.533-8.533v-4.267c0-5.12-3.413-8.533-8.533-8.533     c-5.12,0-8.533,3.413-8.533,8.533v4.267C331.8,170.52,335.213,173.933,340.333,173.933z"></path>
          <path d="M331.8,204.653c0,5.12,3.413,8.533,8.533,8.533c5.12,0,8.533-4.267,8.533-8.533v-9.387c0-5.12-3.413-8.533-8.533-8.533     c-5.12,0-8.533,3.413-8.533,8.533V204.653z"></path>
          <path d="M331.8,237.933c0,5.12,3.413,8.533,8.533,8.533c5.12,0,8.533-3.413,8.533-8.533v-4.267c0-5.12-3.413-8.533-8.533-8.533     c-5.12,0-8.533,3.413-8.533,8.533V237.933z"></path>
          <path d="M374.467,173.933c5.12,0,8.533-3.413,8.533-8.533v-4.267c0-5.12-3.413-8.533-8.533-8.533s-8.533,3.413-8.533,8.533v4.267     C365.933,170.52,369.347,173.933,374.467,173.933z"></path>
          <path d="M365.933,204.653c0,5.12,3.413,8.533,8.533,8.533S383,208.92,383,204.653v-9.387c0-5.12-3.413-8.533-8.533-8.533     s-8.533,3.413-8.533,8.533V204.653z"></path>
          <path d="M365.933,237.933c0,5.12,3.413,8.533,8.533,8.533s8.533-3.413,8.533-8.533v-4.267c0-5.12-3.413-8.533-8.533-8.533     s-8.533,3.413-8.533,8.533V237.933z"></path>
        </g>
      </g>
    </g>
  </svg>
  );
  


  const displayPrice = precio === 0 ? "Consultar" : ` ${precio}`;

  const handleProductClick = () => {
    navigate(`/item/${id}`);
  };

  const imagenes = Array.isArray(imagen) ? imagen : [imagen];

const renderizarImagenes = () => {
  return imagenes.map((img, index) => (
    <SwiperSlide key={index}>
    <div className="image-container" onClick={handleProductClick}>
      <img src={img} alt={nombre} className="img-fluid" />


      {disponibilidad === 'R' && (/* modificar  */
        <div className="vendido-overlay">
          <span>RESERVADA</span>
        </div>
      )}
      {disponibilidad === 'S' && (/* modificar  */
        <div className="vendido-overlay">
          <span>SUSPENDIDA</span>
        </div>
      )}
      {disponibilidad === 'V' && (/* modificar  */
        <div className="vendido-overlay">
          <span>VENDIDA</span>
        </div>
      )}
      {disponibilidad === 'A' && (/* modificar  */
        <div className="vendido-overlay">
          <span>ALQUILADA</span>
        </div>
      )}
    </div>
  </SwiperSlide>
  ));
};


  return (
    <div className="col"  >
      <div className="card shadow productDestacado my-3" onClick={handleProductClick}>
        {Array.isArray(imagen) ? (
          <Swiper spaceBetween={1} slidesPerView={1}>
            {renderizarImagenes()}
          </Swiper>
        ) : (
          <div className="image-container" onClick={handleProductClick}>
            <img src={imagenes[0]} alt={nombre} className="img-fluid" />
              {disponibilidad === 'R' && (/* modificar  */
              <div className="vendido-overlay">
                <span>RESERVADA</span>
              </div>
            )}
            {disponibilidad === 'S' && (/* modificar  */
              <div className="vendido-overlay">
                <span>SUSPENDIDA</span>
              </div>
            )}
            {disponibilidad === 'V' && (/* modificar  */
              <div className="vendido-overlay">
                <span>VENDIDA</span>
              </div>
            )}
            {disponibilidad === 'A' && (/* modificar  */
              <div className="vendido-overlay">
                <span>ALQUILADA</span>
              </div>
            )}
          </div>
        )}

        <div className="card-body">
          <h5 className="card-title">
              {titulo}
          </h5>
          <h5 className="card-title" style={{ color: "green" }}>
            {displayPrice}
          </h5>


          {/* MODIFICAR */}
          <div>          
            <div className="contenedor-svg container">
              <div className="svg" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                {svgSupTotal}
                
                <strong style={{ margin: "0", fontSize: "1.2rem" }}>{Math.floor(superficieTotal)+"m²"}</strong>
                <span style={{ fontSize: "1rem", textAlign:"center" }}> Sup. Total </span>
              </div>
              
              <div className="svg" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                {Ambientes}

                <strong style={{ margin: "0", fontSize: "1.2rem" }}>{ambientes}</strong>
                <span style={{ fontSize: "1rem" }}> Ambientes </span>
              </div>
              <div className="svg" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                {Baños}

                <strong style={{ margin: "0", fontSize: "1.2rem" }}>{baños}</strong>
                <span style={{ fontSize: "1rem" }}> Baños </span>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ItemDetails;

